<div class="row mb-2">
  <div class="col-md-2">
    <select [(ngModel)]="searchBy" class="form-control">
      <option value="">Select Search By</option>
      <option value="vehicleId">Vehicle ID</option>
      <option value="vehicleName">Vehicle Name</option>
      <!-- <option value="vehicleContactName">Vehicle Owner</option> -->
      <option value="type">Vehicle Type</option>
      <!-- <option value="vehicleCity">City</option> -->
    </select>
  </div>
  <div class="col-md-2">
    <input
      type="search"
      [(ngModel)]="searchText"
      class="form-control mb-2"
      placeholder="Search Text"
    />
  </div>
  <div class="col-md-2">
    <button
      (click)="search()"
      class="btn btn-primary btn-block"
      [disabled]="searchBy == ''"
    >
      Search <i class="fa fa-search"></i>
    </button>
  </div>

  <div class="col-md-6 m-0 text-end">
    <!-- <button (click)="openAddVehicleModal(content1)"   class="btn-shadow d-inline-flex align-items-center btn btn-success">   <fa-icon [icon]="faPlus" class="me-2"></fa-icon> Add Vehicle 
            </button> -->
    <button
      (click)="exportToExcel()"
      style="margin: 0px 5px 0px 5px !important"
      class="btn-shadow d-inline-flex align-items-center btn btn-success"
    >
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export Current Excel
    </button>
    <button class="btn-shadow d-inline-flex align-items-center btn btn-success">
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export All Excel
    </button>
  </div>
</div>

<div class="main-card mb-3 card">
  <div class="card-header font-weight-B fs-1r">All Vehicles</div>
  <div class="table-responsive">
    <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
      id="excel-table"
    >
      <thead>
        <tr>
          <th>Vehicle ID</th>
          <th>Type</th>
          <th>Rating</th>
          <th>Activation Status</th>
          <th class="text-end">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let data of allVehicleList
              | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  }
          "
        >
          <td class="w-16">
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.vehicleId }}</div>
                </div>
              </div>
            </div>
          </td>

          <td class="w-16">
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.type }}</div>
                </div>
              </div>
            </div>
          </td>

          <td class="w-17">
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.rating }} / 5</div>
                </div>
              </div>
            </div>
          </td>

          <td class="w-15">
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    <label class="switch">
                      <input
                        type="checkbox"
                        (ngModelChange)="getActivationToggleData($event, data)"
                        [(ngModel)]="data.currentStatus"
                      />
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td class="text-end">
            <div class="dropdown">
              <button
                class="btn btn-info dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Action
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a class="dropdown-item" (click)="routeViewDetails(data)"
                    >View Details <i class="fa fa-eye"></i
                  ></a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    (click)="editVehicle(editModal, data)"
                    >Edit <i class="fa fa-pencil"></i
                  ></a>
                </li>
                <li>
                  <a class="dropdown-item" (click)="deleteVehicle(data)"
                    >Delete <i class="fa fa-trash"></i
                  ></a>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
      <div *ngIf="allVehicleList?.length == 0" class="text-center mt-5 mb-5">
        <span class="text-danger">Data Not found</span>
      </div>
    </table>
    <!-- <pagination-controls
      class="my-pagination"
      (pageChange)="gty((page = $event))"
    ></pagination-controls> -->

    <ngb-pagination
      (pageChange)="gty((page = $event))"
      [collectionSize]="totalItems"
      [(page)]="page"
      [pageSize]="itemsPerPage"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="false"
    >
    </ngb-pagination>
  </div>
</div>

<!-- Edit Vehicle Details Model -->
<div class="card-body">
  <ng-template #editModal let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title"><i class="fa fa-pencil"> Edit Vehicle</i></h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click')"
      ></button>
    </div>

    <div class="modal-body">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <button
            class="nav-link active"
            id="nav-details-tab"
            data-bs-toggle="tab"
            data-bs-target="#editDetails"
            type="button"
            role="tab"
            aria-controls="editDetails"
            aria-selected="true"
          >
            <i class="fa fa-info" aria-hidden="true"></i> Vehicle Details
          </button>
          <button
            class="nav-link"
            id="nav-docs-tab"
            data-bs-toggle="tab"
            data-bs-target="#editRange"
            type="button"
            role="tab"
            aria-controls="editRange"
            aria-selected="false"
          >
            <i class="fa fa-file-text" aria-hidden="true"></i> Range Details
          </button>
        </div>
      </nav>

      <div class="tab-content" id="nav-tabContent">
        <div
          class="tab-pane fade show active"
          id="editDetails"
          role="tabpanel"
          aria-labelledby="editDetails-tab"
        >
          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <label for="">Vehicle ID : </label>
              <input
                type="text"
                [(ngModel)]="vehicleid"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-4">
              <label for=""> ID : </label>
              <input
                type="text"
                [(ngModel)]="userId"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2"></div>
          </div>

          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <label for="">Vehicle Type : </label>
              <input
                type="text"
                [(ngModel)]="vehicleType"
                class="form-control"
                placeholder="Vehicle type"
              />
            </div>
            <div class="col-md-4">
              <label for="">Vehicle Capacity : </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="vehicleCapacity"
                class="form-control"
                placeholder="vehicle capacity"
              />
            </div>
            <div class="col-md-2"></div>
          </div>

          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-3">
              <label for="">Original Price(per KM): </label>
              <input
                type="text"
                [(ngModel)]="originalPrice"
                class="form-control"
                placeholder="Original price"
              />
            </div>
            <div class="col-md-3">
              <label for="">Discount Price(per KM): </label>
              <input
                type="text"
                [(ngModel)]="discountPrice"
                class="form-control"
                placeholder="Discount price "
              />
            </div>
            <div class="col-md-2">
              <label for="">Rating(Out of 5): </label>
              <input
                type="number"
                [(ngModel)]="rating"
                class="form-control"
                placeholder="rating"
                max="5"
                min="1"
              />
            </div>
            <div class="col-md-2"></div>
          </div>

          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-3">
              <label for="">Vehicle Size (Length): </label>
              <input
                type="text"
                [(ngModel)]="vehicleLength"
                class="form-control"
                placeholder="Length (ex-1ft)"
              />
            </div>
            <div class="col-md-3">
              <label for="">(Breadth): </label>
              <input
                type="text"
                [(ngModel)]="vehicleBreadth"
                class="form-control"
                placeholder="Breadth (ex-1ft) "
              />
            </div>
            <div class="col-md-2">
              <label for="">(Height): </label>
              <input
                type="text"
                [(ngModel)]="vehicleHeight"
                class="form-control"
                placeholder="Height (ex-1ft)"
              />
            </div>
            <div class="col-md-2"></div>
          </div>

          <div class="row">
            <div class="col-md-2"></div>

            <div class="col-md-2"></div>
          </div>

          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-8">
              <label for="">Terms & Conditions: </label>
              <input
                type="text"
                [(ngModel)]="termsAndConditions"
                class="form-control"
                placeholder="terms & conditions"
                max="5"
                min="1"
              />
            </div>

            <div class="col-md-2"></div>
          </div>

          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <label for="">Vehicle Image : </label>
              <div>
                <input
                  type="file"
                  (change)="getVehicleImage($event)"
                  placeholder="Vehicle Image"
                />
                <div *ngIf="isValidImage == true" class="text-danger">
                  Please Select image file
                </div>
                <div *ngIf="isImageUploaded == true" class="text-success">
                  Image Uploaded Successfully
                </div>
              </div>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-3">
              <label for="">Labour Available : </label> <br />
              <label class="switch">
                <input
                  type="checkbox"
                  (ngModelChange)="labourAvail($event)"
                  [(ngModel)]="labourAvailable"
                />
                <span class="slider round"></span>
              </label>
            </div>

            <div class="col-md-2"></div>
          </div>

          <div class="row mt-3 mb-3 text-center">
            <div class="col-md-12">
              <button
                (click)="updateVehicle()"
                [disabled]="
                  termsAndConditions == '' ||
                  originalPrice == '' ||
                  vehicleLength == '' ||
                  vehicleBreadth == '' ||
                  vehicleHeight == '' ||
                  discountPrice == '' ||
                  originalPrice == '' ||
                  vehicleType == '' ||
                  isValidImage == true
                "
                class="btn btn-primary btn-lg btn-block"
              >
                Update Vehicle
              </button>
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade show"
          id="editRange"
          role="tabpanel"
          aria-labelledby="editRange-tab"
        >
        <div class="row justify-content-center" >


           <!-- Select Range and set Prices -->
           <div class="row" *ngIf="allRanges.length">
            <!-- Range Selection Dropdown -->
            <div class="col-md-2"></div>
            <div class="col-md-3">
              <label for="rangeSelect">Select Range (KM):</label>
              <select
                id="rangeSelect"
                [(ngModel)]="selectedRange"
                name="rangeSelect"
                class="form-control"
                (change)="onRangeChange()"
              >
                <option value="">Select Range</option>
                <option *ngFor="let range of allRanges" [ngValue]="range">
                  {{ range.min }} - {{ range.max }} KM
                </option>
              </select>
            </div>

            <!-- Price Input -->
            <div class="col-md-2">
              <label for="price">Price:</label>
              <input
                type="number"
                min="0"
                id="price"
                [(ngModel)]="priceInput"
                name="price"
                class="form-control"
                placeholder="Enter price"
                required
              />
            </div>

            <!-- Discounted Price Input -->
            <div class="col-md-2">
              <label for="discountedPrice">Discount Price:</label>
              <input
                type="number"
                min="0"
                id="discountedPrice"
                [(ngModel)]="discountedPriceInput"
                name="discountedPrice"
                class="form-control"
                placeholder="Enter discounted price"
                required
              />
            </div>

            <!-- Add Vehicle Price Button -->
            <div class="col-md-2 d-flex align-items-end">
              <button  (click)="updateVehiclePrice(allRanges.indexOf(selectedRange))" class="btn btn-primary">
                Add
              </button>
            </div>
          </div>

           <!-- Display Message below the inputs -->
           <div class="text-center m-0 p-0">
            <p
              *ngIf="message"
              [ngClass]="
                messageType === 'error' ? 'text-danger' : 'text-success'
              "
            >
              {{ message }}
            </p>
          </div>

          <!-- Amounts Table -->
          <div class="col-md-8">
            <h4 class="mt-4">Prices for {{ vehicleType }}:</h4>
            <table class="table table-bordered table-striped table-hover">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Range (KM)</th>
                  <th>Price ( <span class="fa fa-inr"></span> per KM)</th>
                  <th>
                    Discounted Price ( <span class="fa fa-inr"></span> per KM)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let vp of vehiclePrice let i = index"
                  class="font-weight-B"
                >
                  <td>{{i+1}}</td>
                  <td>{{ vp.min }} - {{ vp.max }}</td>
                  <td>{{ vp.price }}</td>
                  <td>{{ vp.discountedPrice }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row mt-3 mb-3 text-center">
          <div class="col-md-12">
            <button
              (click)="checkMinMaxSync()"
              class="btn btn-primary btn-lg btn-block"
            >
              Update Prices
            </button>
          </div>
        </div>
      </div>
      </div>

      <!-- 
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">Vehicle ID : </label>
          <input
            type="text"
            [(ngModel)]="vehicleid"
            class="form-control"
            [disabled]="true"
          />
        </div>
        <div class="col-md-4">
          <label for=""> ID : </label>
          <input
            type="text"
            [(ngModel)]="userId"
            class="form-control"
            [disabled]="true"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">Vehicle Type : </label>
          <input
            type="text"
            [(ngModel)]="vehicleType"
            class="form-control"
            placeholder="Vehicle type"
          />
        </div>
        <div class="col-md-4">
          <label for="">Vehicle Capacity : </label>
          <input
            type="text"
            [(ngModel)]="vehicleCapacity"
            class="form-control"
            placeholder="vehicle capacity"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-3">
          <label for="">Original Price(per KM): </label>
          <input
            type="text"
            [(ngModel)]="originalPrice"
            class="form-control"
            placeholder="Original price"
          />
        </div>
        <div class="col-md-3">
          <label for="">Discount Price(per KM): </label>
          <input
            type="text"
            [(ngModel)]="discountPrice"
            class="form-control"
            placeholder="Discount price "
          />
        </div>
        <div class="col-md-2">
          <label for="">Rating(Out of 5): </label>
          <input
            type="number"
            [(ngModel)]="rating"
            class="form-control"
            placeholder="rating"
            max="5"
            min="1"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-3">
          <label for="">Vehicle Size (Length): </label>
          <input
            type="text"
            [(ngModel)]="vehicleLength"
            class="form-control"
            placeholder="Length (ex-1ft)"
          />
        </div>
        <div class="col-md-3">
          <label for="">(Breadth): </label>
          <input
            type="text"
            [(ngModel)]="vehicleBreadth"
            class="form-control"
            placeholder="Breadth (ex-1ft) "
          />
        </div>
        <div class="col-md-2">
          <label for="">(Height): </label>
          <input
            type="text"
            [(ngModel)]="vehicleHeight"
            class="form-control"
            placeholder="Height (ex-1ft)"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>

        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <label for="">Terms & Conditions: </label>
          <input
            type="text"
            [(ngModel)]="termsAndConditions"
            class="form-control"
            placeholder="terms & conditions"
            max="5"
            min="1"
          />
        </div>

        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">Vehicle Image : </label>
          <div>
            <input
              type="file"
              (change)="getVehicleImage($event)"
              placeholder="Vehicle Image"
            />
            <div *ngIf="isValidImage == true" class="text-danger">
              Please Select image file
            </div>
            <div *ngIf="isImageUploaded == true" class="text-success">
              Image Uploaded Successfully
            </div>
          </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-3">
          <label for="">Labour Available : </label> <br />
          <label class="switch">
            <input
              type="checkbox"
              (ngModelChange)="labourAvail($event)"
              [(ngModel)]="labourAvailable"
            />
            <span class="slider round"></span>
          </label>
        </div>

        <div class="col-md-2"></div>
      </div>

      <div class="row mt-3 mb-3 text-center">
        <div class="col-md-12">
          <button
            (click)="updateVehicle()"
            [disabled]="
              termsAndConditions == '' ||
              originalPrice == '' ||
              vehicleLength == '' ||
              vehicleBreadth == '' ||
              vehicleHeight == '' ||
              discountPrice == '' ||
              originalPrice == '' ||
              vehicleType == '' ||
              isValidImage == true
            "
            class="btn btn-primary btn-lg btn-block"
          >
            Update Vehicle
          </button>
        </div>
      </div> -->
    </div>
  </ng-template>
</div>
